import React from 'react'
import styled from 'styled-components'
import LuxPlus from './Logos/LuxPlus'
import { LUXURY_PLUS } from 'loyalty/constants/base'

const LogoWrapper = styled.span`
  line-height: 1;
  display: inline-flex;
`

interface Props extends React.SVGAttributes<SVGSVGElement> {}

export default function LuxuryPlusLogo({ height, ...rest }: Props) {
  return <LogoWrapper style={{ height: height ?? 10 }} aria-label={`${LUXURY_PLUS.PROGRAM_NAME} logo`}>
    <LuxPlus aria-hidden="true" {...rest} />
  </LogoWrapper>
}
